<template>
  <div class="question-item bg-white box-border px-10 py-4">
    <div class="relative">
      <div :class="{ 'unknown-wrap': question.issue.show_unknown }">
        <div ref="title" class="q-title leading-22 break-words" v-html="title"></div>
      </div>
      <div class="q-desc-wrap" :class="[isOverFlowNote ? 'pb-8' : '']">
        <div ref="note" class="q-desc break-words leading-22 pl-5" :class="getNoteClass" v-if="showNote">
          <div v-html="question.note"></div>
        </div>
        <div v-if="isOverFlowNote" class="operate-btn cursor-pointer" @click="isOpenNote = !isOpenNote">
          <span class="text-theme">{{ isOpenNote ? '收起' : '展开' }}</span>
          <span>
            <i :class="isOpenNote ? 'el-icon-arrow-up' : 'el-icon-arrow-down'"></i>
          </span>
        </div>
      </div>
      <div class="q-content pl-7.5 mt-3" ref="qContent">
        <component :is="componentName" :question="question" view />
      </div>

      <template v-if="content.allowPhotoNum && content.allowPhotoNum > 0">
        <div class="pl-7.5">
          <adapter-upload-files :content="content" />
        </div>
      </template>
      <div class="pl-7.5 mt-2" v-if="hasAnswerScore">
        <div class="bg-card-bg-gray py-4 px-4 mt-2 leading-18 rounded-small">
          <div v-if="!isCorrectAnswer">
            <span class="correct-answer correct-error text-danger">回答错误 +0分</span>
          </div>
          <div v-else>
            <span class="text-green-theme">回答正确 {{ score > 0 ?'+'+score :score }}分</span>
          </div>
          <!--          <div class="mb-2" v-if="!isCorrectAnswer">
            <div>
              <span>正确答案</span>
            </div>
            <ul>
              <li v-for="item in correctAnswerList" :key="item.id">
                <div v-html="item.content.richText"></div>
              </li>
            </ul>
          </div>-->
          <div v-if="answerScore.answerAnalysis">
            <span class="text">答案解析：</span>
            <span class="analysis" v-html="answerScore.answerAnalysis"></span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import QuestionItem from '@/components/QuestionItem'

export default {
  name: 'PreviewQuestion',
  extends: QuestionItem,
  props: {},
  computed: {
    hasAnswerScore() {
      if (!this.question.setting.enableAnswerScore) return false
      return !!(this.answerScore.optionScoreItems || []).length
    },
    answerScore() {
      return this.question.answerScore || {}
    },
    isCorrectAnswer() {
      if (!this.question.setting.enableAnswerScore) return false
      const issue = this.question.issue
      if (issue.isCorrectAnswer) {
        return issue.isCorrectAnswer(this.answerScore)
      } else {
        return true
      }
    },
    correctAnswerList() {
      const issue = this.question.issue
      if (issue.getCorrectAnswerList) {
        return this.question.getCorrectAnswerList(this.answerScore)
      } else {
        return []
      }
    },
    totalScore() {
      const issue = this.question.issue
      if (issue.getTotalScore) {
        return issue.getTotalScore(this.answerScore)
      } else {
        return ''
      }
    },
    score() {
      if (!this.question.setting.enableAnswerScore) return ''
      const issue = this.question.issue
      if (issue.getScore) {
        return issue.getScore(this.answerScore)
      } else {
        return ''
      }
    }
  },
  methods: {},
  mounted() {},
  provide(){
    return {
      view: true
    }
  }
}
</script>
